export default "__VITE_ASSET__D73_isvy__"